<template>
  <div :class="{ 'display-none': !isActive }" class="sf-content-page">
    <slot />
  </div>
</template>
<script>
export default {
  name: "ContentPage",
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: [String, Array],
      default: "",
    },
    val: {
      type: String,
      default: "",
    }
  },
  inject: ["provided"],
  computed: {
    isActive() {
      return this.provided.active?.toLowerCase() === this.val?.toLowerCase();
    },
  },
  mounted() {
    const item = {
      title: this.title,
      icon: this.icon,
      val: this.val
    };
    this.$parent.items.push(item);
  },
};
</script>
